import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InitializationService {
  private isReadySubject = new BehaviorSubject<boolean>(false);
  public isReady$: Observable<boolean> = this.isReadySubject.asObservable();

  constructor() {
    // Services are constructed synchronously. Yield once so the first navigation
    // does not sit on a blank overlay waiting out a fixed timer.
    queueMicrotask(() => this.markAsReady());
  }

  markAsReady(): void {
    this.isReadySubject.next(true);
  }

  isReady(): boolean {
    return this.isReadySubject.value;
  }

  /**
   * Resolves when startup has marked itself ready. A guard that waits forever
   * leaves the post-login navigation hanging on a blank outlet, so this settles
   * on its own if that signal never arrives.
   */
  waitForReady(): Promise<boolean> {
    return new Promise((resolve) => {
      let settled = false;
      let subscription: { unsubscribe(): void } | undefined;
      const finish = () => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        subscription?.unsubscribe();
        resolve(true);
      };
      const timer = window.setTimeout(() => {
        if (!this.isReady()) {
          console.error('Initialization timed out; continuing so the shell can render');
          this.markAsReady();
        }
        finish();
      }, 5000);
      if (this.isReady()) {
        finish();
        return;
      }
      subscription = this.isReady$.subscribe((ready) => {
        if (ready) finish();
      });
    });
  }
}